import React, { useEffect, useRef, useState, useCallback } from 'react';
import { CATS, sc, DirtIcon } from '../constants';

export default function NewsFeed({ byCat, hovCat, setHovCat, hovArticle, setHovArticle, hovY, setHovY, newsContainerRef }) {
  const scrollRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateArrows = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const hasOverflow = el.scrollWidth > el.offsetWidth + 5;
    setCanScrollRight(hasOverflow && el.scrollLeft + el.offsetWidth < el.scrollWidth - 5);
    setCanScrollLeft(el.scrollLeft > 5);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    updateArrows();
    el.addEventListener('scroll', updateArrows, { passive: true });
    return () => el.removeEventListener('scroll', updateArrows);
  }, [updateArrows]);

  const arrowBtn = {
    width: 28, height: 28, borderRadius: '50%',
    background: '#111', border: '1px solid #1a1a1a',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer', color: '#fff', fontSize: 14, padding: 0,
  };

  return (
    <section style={{ marginTop: 24 }} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      {/* arrows visible at all widths */}
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
        <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#ff1744", animation: "pulse 2s infinite" }} />
        <span style={{ fontSize: 13, fontFamily: "JetBrains Mono", fontWeight: 700, color: "var(--bs-ink, #fff)", letterSpacing: 1.5 }}>LATEST HEADLINES</span>
        {hovered && (
          <div className="nf-arrow" style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
            <button
              onClick={() => scrollRef.current?.scrollBy({ left: -200, behavior: 'smooth' })}
              style={{ ...arrowBtn, opacity: canScrollLeft ? 1 : 0.3, pointerEvents: canScrollLeft ? 'auto' : 'none' }}
            >&#8249;</button>
            <button
              onClick={() => scrollRef.current?.scrollBy({ left: 200, behavior: 'smooth' })}
              style={{ ...arrowBtn, opacity: canScrollRight ? 1 : 0.3, pointerEvents: canScrollRight ? 'auto' : 'none' }}
            >&#8250;</button>
          </div>
        )}
      </div>

      <div
        ref={newsContainerRef}
        style={{ position: "relative", overflow: "visible" }}
      >

        <div ref={scrollRef} style={{ display: "flex", gap: 8, overflowX: "auto", paddingBottom: 8, scrollbarWidth: "none" }}>
          {CATS.map(cat => {
            const arts = byCat(cat), p = arts[0], exp = hovCat === cat;
            return (
              <div key={cat} onMouseEnter={() => setHovCat(cat)} onMouseLeave={() => { setHovCat(null); setHovArticle(null); }}
                style={{ flex: "0 0 auto", width: 170, minWidth: 170, background: exp ? "var(--bs-bg, #0d0d0d)" : "var(--bs-surface, #111)", border: exp ? "1px solid var(--bs-green-bd, #00e67633)" : "1px solid var(--bs-border, #1a1a1a)", borderRadius: 10, padding: 12, cursor: "pointer", transition: "all .2s", minHeight: 100 }}>
                <div style={{ fontSize: 10, fontFamily: "JetBrains Mono", fontWeight: 700, color: "var(--bs-green, #00e676)", letterSpacing: 2, marginBottom: 2 }}>{cat.toUpperCase()}</div>
                <div style={{ fontSize: 10, color: "var(--bs-green, #444)", marginBottom: 8 }}>{arts.length} articles</div>
                {p && !exp && <div style={{ overflow: "hidden", height: 70 }}>
                  <div style={{ animation: `tickerScroll ${arts.slice(0,5).length * 3}s linear infinite` }}>
                    {[...arts.slice(0, 5), ...arts.slice(0, 5)].map((a, i) => (
                      <div key={`${a.id}-${i}`} style={{ padding: "3px 0", borderBottom: "1px solid var(--bs-border, #1a1a1a)" }}>
                        <p style={{ fontSize: 11, color: "var(--bs-body, #ccc)", lineHeight: 1.3, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{a.title}</p>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 1 }}>
                          <span style={{ fontSize: 9, color: "var(--bs-muted, #555)" }}>{a.outlet || a.source || ''}</span>
                          <span style={{ fontSize: 9, fontFamily: "JetBrains Mono", fontWeight: 700, color: a.paydirtScore ? sc(a.paydirtScore) : "var(--bs-muted, #555)" }}>{a.paydirtScore ? `${DirtIcon(a.paydirtScore)}${a.paydirtScore}%` : '⏳'}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>}
                {exp && arts.length > 0 && <div style={{ display: "flex", flexDirection: "column", gap: 2, maxHeight: 160, overflow: "auto", position: "relative", zIndex: 40 }}>
                  {arts.slice(0, 20).map((a, i) => (
                    <a key={a.id || i} href={a.url} target="_blank" rel="noopener noreferrer"
                      onMouseEnter={(e) => { setHovArticle(a); if (newsContainerRef.current) { const cr = newsContainerRef.current.getBoundingClientRect(); const rr = e.currentTarget.getBoundingClientRect(); setHovY(rr.top - cr.top); } }}
                      onMouseLeave={() => setHovArticle(null)}
                      style={{ display: "flex", alignItems: "center", gap: 4, padding: "4px 6px", borderRadius: 4, fontSize: 11, textDecoration: "none", color: "inherit", animation: "slideIn .15s ease forwards", animationDelay: `${i * 30}ms`, background: hovArticle?.id === a.id ? "var(--bs-green-bg, #00e67611)" : "transparent", border: hovArticle?.id === a.id ? "1px solid var(--bs-green-bd, #00e67633)" : "1px solid transparent", cursor: "pointer", transition: "background .1s, border .1s" }}>
                      <span style={{ fontSize: 9, fontFamily: "JetBrains Mono", fontWeight: 700, padding: "1px 5px", borderRadius: 3, flexShrink: 0, background: a.paydirtScore ? sc(a.paydirtScore) + "22" : "var(--bs-border, #33333344)", color: a.paydirtScore ? sc(a.paydirtScore) : "var(--bs-muted, #555)" }}>{a.paydirtScore ? `${DirtIcon(a.paydirtScore)}${a.paydirtScore}%` : '⏳'}</span>
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: hovArticle?.id === a.id ? "var(--bs-ink, #fff)" : "var(--bs-body, #ccc)", flex: 1, transition: "color .1s" }}>{a.title}</span>
                    </a>))}
                </div>}
              </div>);
          })}
        </div>

        {hovArticle && (
          <div style={{
            position: "absolute", top: hovY - 4, left: 0, right: 0, zIndex: 100,
            pointerEvents: "none",
            display: "flex", alignItems: "center", gap: 8, padding: "9px 16px",
            background: "var(--bs-surface, #0d0d0d)", border: "1px solid var(--bs-green-bd, #00e67666)", borderRadius: 8,
            boxShadow: "0 6px 32px rgba(0,0,0,0.7), 0 0 0 1px #00e67622",
            animation: "fadeSlideIn .12s ease"
          }}>
            <span style={{ fontSize: 11, fontFamily: "JetBrains Mono", color: "var(--bs-green, #00e676)", flexShrink: 0, fontWeight: 700, letterSpacing: 0.5 }}>{hovArticle.outlet || hovArticle.source || ''}</span>
            <div style={{ width: 1, height: 16, background: "var(--bs-border, #333)", flexShrink: 0 }} />
            <span style={{ fontSize: 12.5, color: "var(--bs-ink, #f0f0f0)", lineHeight: 1.3, fontWeight: 500, flex: 1 }}>{hovArticle.title}</span>
            <div style={{ width: 1, height: 16, background: "var(--bs-border, #333)", flexShrink: 0 }} />
            <span style={{ fontSize: 11, fontFamily: "JetBrains Mono", fontWeight: 700, padding: "2px 8px", borderRadius: 4, background: hovArticle.paydirtScore ? sc(hovArticle.paydirtScore) + "33" : "var(--bs-border, #33333344)", color: hovArticle.paydirtScore ? sc(hovArticle.paydirtScore) : "var(--bs-muted, #555)", flexShrink: 0, border: `1px solid ${hovArticle.paydirtScore ? sc(hovArticle.paydirtScore) + "44" : "var(--bs-border, #33333366)"}`, whiteSpace: "nowrap" }}>{hovArticle.paydirtScore ? `${DirtIcon(hovArticle.paydirtScore)}PayDirt Score — ${hovArticle.paydirtScore}%` : '⏳ Unscored'}</span>
          </div>
        )}
      </div>
    </section>
  );
}
